<template>
  <div id="root">
    <router-view />
  </div>
</template>

<script>
  import router from './router'
  import {getCarmallSign} from './api'; // eslint-disable-line

  export default {
    name: 'App',
    router,
    mounted() {
      // getCarmallSign(138);
    }
  }
</script>

<style lang="scss" scoped>
  #root {
    min-height: 100vh;
    width: 100vw;
    box-sizing: border-box;
    background-color: #fff;
  }
</style>
